import { useState } from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";
import Alert from "@mui/material/Alert";
import Paper from "@mui/material/Paper";

export function UrlUpdateSection(props: {
  currentUrl: string;
  onUpdateUrl: (newUrl: string) => void;
  state: { kind: string };
}) {
  const [newUrl, setNewUrl] = useState("");

  return (
    <Paper variant="outlined" sx={{ p: 2, mb: 3 }}>
      <Typography variant="subtitle1" gutterBottom fontWeight="bold">
        Замена целевого URL
      </Typography>
      <Box display="flex" gap={1} alignItems="center">
        <TextField
          size="small"
          placeholder="Новый URL"
          value={newUrl}
          onChange={(event) => setNewUrl(event.target.value)}
          fullWidth
        />
        <Button
          variant="contained"
          onClick={() => props.onUpdateUrl(newUrl)}
          disabled={props.state.kind === "loading" || newUrl.length === 0}
        >
          {props.state.kind === "loading" ? "Обновление…" : "Обновить URL"}
        </Button>
      </Box>
      {props.state.kind === "success" && (
        <Alert severity="success" sx={{ mt: 1 }}>URL обновлён</Alert>
      )}
      {props.state.kind === "error" && (
        <Alert severity="error" sx={{ mt: 1 }}>Ошибка обновления URL</Alert>
      )}
    </Paper>
  );
}
